import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NiceSessionManagementService {
  private readonly niceSessionLocalStorageKey = '@iframe-nice-session';
  private readonly niceSessionUpdateTime = 1000;
  /*
     max durantion without the main tab update the local storage
  */
  private readonly niceSessissionTimeValidation = 3000;

  updateNiceSession() {
    const worker = new Worker(
      new URL('./nice-session.worker', import.meta.url),
    );
    worker.postMessage({
      updateIme: this.niceSessionUpdateTime,
    });

    worker.onmessage = ({ data }) => {
      window.localStorage.setItem(this.niceSessionLocalStorageKey, data);
    };
  }

  checkNiceSessionExpiration(): boolean {
    const storedTimeString = window.localStorage.getItem(
      this.niceSessionLocalStorageKey,
    );
    if (!storedTimeString) {
      return true; // No stored time means expired
    }

    const storedTime = new Date(storedTimeString).getTime();
    const currentTime = Date.now();

    const timeDifference = currentTime - storedTime;
    return timeDifference > this.niceSessissionTimeValidation;
  }
}
